export default [
    // packages ordered by priority
    "HTT",
    "HTTF",
    "PFTT",
    "PFTTF",
    "PFPTT",
    "PFPTTF",
    "PFTTNL",
    "PFPTTNL",
    "PFTTUK",
    "PFPTTUK",
    "PFTT_7",
    "PFTT_8",
];
